module.exports = __webpack_public_path__ + "img/warning-icon.efeb4f94.svg";